import React from 'react';

import { PopperProps, Popper as MuiPopper } from '@mui/material';
// import { NestedFormProvider } from '@travelity/form';

export const Popper: React.FC<PopperProps> = props => {
    return <MuiPopper {...props} />;
};
